import React, { forwardRef } from 'react';
import { withStyles, IconButton as IconButtonMUI } from '@material-ui/core';

const SHELF_BLUE_8 = 'rgba(0, 113, 219, 0.08)';
const SHELF_BLUE_14 = 'rgba(0, 113, 219, 0.14)';
const RESTING_COLOR = '#394551';
const FOCUS_BORDER = '#043C74';
const DISABLED_COLOR = '#989898';

const IconButtonWrapper = forwardRef(({ isPressed, ...props }, ref) => (
  <IconButtonMUI {...props} ref={ref} />
));

const StyledIconButton = withStyles((theme) => {
  return {
    root: {
      color: RESTING_COLOR,
      border: '2px solid transparent',
      boxSizing: 'border-box',
      cursor: 'pointer',
      width: theme.spacing(5.5), // 44px
      height: theme.spacing(5.5),
      backgroundColor: ({ 'aria-pressed': ariaPressed, isPressed }) =>
        [ariaPressed, isPressed].some((value) => String(value) === 'true')
          ? SHELF_BLUE_14
          : 'transparent',
      '&:hover:not(.Mui-disabled):not(:disabled):not([aria-pressed="true"])': {
        backgroundColor: SHELF_BLUE_8,
      },
      '&[aria-pressed="true"]:hover:not(.Mui-disabled):not(:disabled)': {
        backgroundColor: SHELF_BLUE_14,
      },
      '&:active:not(.Mui-disabled):not(:disabled)': {
        backgroundColor: SHELF_BLUE_14,
      },
      '&:focus-visible:not(.Mui-disabled)': {
        backgroundColor: SHELF_BLUE_8,
        borderColor: FOCUS_BORDER,
        outline: 'none',
      },
      '&[aria-pressed="true"]:focus-visible:not(.Mui-disabled)': {
        backgroundColor: SHELF_BLUE_14,
        borderColor: FOCUS_BORDER,
      },
      '&.Mui-disabled': {
        color: DISABLED_COLOR,
        opacity: 1,
        borderColor: 'transparent',
        backgroundColor: 'transparent',
      },
    },
  };
})(IconButtonWrapper);

const IconButton = ({ isPressed, children, ...props }, ref) => {
  const isPressedProp = String(isPressed) === 'true';

  return (
    <StyledIconButton
      ref={ref}
      disableFocusRipple
      {...props}
      isPressed={isPressedProp}
    >
      {children}
    </StyledIconButton>
  );
};

export default forwardRef(IconButton);
